import { Box } from '@mui/material'
// biome-ignore lint/style/useImportType: <Not a type-only import>
import React from 'react'
import PerkBadge from './PerkBadge'
import {
  BadgeLayout,
  BadgeType,
  type PerkBadgesProps,
} from './types/badge.types'

const PerkBadges: React.FC<PerkBadgesProps> = ({
  isTechstarsCompany,
  isGlobalNetworkPartner,
  categories = [],
  layout = BadgeLayout.HORIZONTAL,
}) => {
  const badges: JSX.Element[] = []

  // Priority badges first (as in original PerkModal logic)
  if (isTechstarsCompany) {
    badges.push(
      <PerkBadge
        key="techstars-company"
        type={BadgeType.TECHSTARS_COMPANY}
        label="Techstars Company"
      />,
    )
  }

  if (isGlobalNetworkPartner) {
    badges.push(
      <PerkBadge
        key="global-network-partner"
        type={BadgeType.GLOBAL_NETWORK_PARTNER}
        label="Global Network Partner"
      />,
    )
  }

  // Category badges last
  for (const category of categories) {
    badges.push(
      <PerkBadge type={BadgeType.CATEGORY} label={category} key={category} />,
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: layout === BadgeLayout.VERTICAL ? 'column' : 'row',
        flexWrap: layout === BadgeLayout.HORIZONTAL ? 'wrap' : 'nowrap',
        alignItems: 'flex-start',
        gap: 1,
      }}
    >
      {badges}
    </Box>
  )
}

export default PerkBadges
